var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"p-1 px-2 nats-font w-100",staticStyle:{"font-size":"1rem"},attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }